import { render } from "./SalesByCustomerReport.vue?vue&type=template&id=4612e5d2&scoped=true"
import script from "./SalesByCustomerReport.vue?vue&type=script&lang=js"
export * from "./SalesByCustomerReport.vue?vue&type=script&lang=js"

import "../inventory/inventoryReport.css?vue&type=style&index=0&id=4612e5d2&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4612e5d2"]])

export default __exports__